import { STATUS_SEGMENT_COLORS } from '@/features/telemetry/config';

/**
 * djb2 string hash. Cheap, deterministic, and evenly distributed enough for a
 * 12-colour palette — this is a colour assignment, not a security primitive.
 */
function hashString(value: string): number {
  let hash = 5381;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 33) ^ value.charCodeAt(i);
  }
  return Math.abs(hash);
}

/**
 * Deterministic colour for an opaque status value. Never a semantic lookup — the same
 * raw string always gets the same colour, but the mapping carries no meaning (a status
 * of `"error"` is not guaranteed to be red).
 */
export function statusColor(status: string): string {
  const index = hashString(status) % STATUS_SEGMENT_COLORS.length;
  return STATUS_SEGMENT_COLORS[index];
}
